// extracted by mini-css-extract-plugin
var _1 = "vPEke";
export { _1 as "base" }
